<template>
  <component :is="currentTag" :class="classes">
    <slot/>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

// Props
interface Props {
  tag?: string
  name: string
  color?: string
}

const props = withDefaults(defineProps<Props>(), {
  tag: 'div'
})

// Constants
const tags = ["h1", "h2", "h3", "h4", "h5", "h6", "div", "p", "a", "span"]
const names = ["h1", "h2", "h3", "h4", "h5", "h6", "h7", "sub1", "sub2", "sub3", "sub4", "body1", "body2", "body3", "body4", "button2", "tag1"]

// Computed properties
const currentTag = computed((): string => {
  return props.tag || "div"
})

const defaultColor = computed((): string => {
  return "black_white"
})

const currentColor = computed((): string => {
  if (!props.color) {
    switch (props.name) {
      case "h1":
        return defaultColor.value
      case "h2":
        return defaultColor.value
      case "h3":
        return defaultColor.value
      case "h4":
        return defaultColor.value
      case "h5":
        return defaultColor.value
      case "h6":
        return defaultColor.value
      case "sub1":
        return defaultColor.value
      case "sub2":
        return defaultColor.value
      case "sub3":
        return defaultColor.value
      case "sub4":
        return defaultColor.value
      case "body1":
        return defaultColor.value
      case "body2":
        return defaultColor.value
      case "body3":
        return "gray5_gray"
      case "body4":
        return defaultColor.value
      case "button2":
        return defaultColor.value
      default:
        return defaultColor.value
    }
  }
  return props.color
})

const classes = computed((): string => {
  return `${props.name} ${currentColor.value}--text`
})
</script>
